import {DateTime} from "luxon";

/** Today's date key in the player's local timezone, e.g. "2026-07-03". */
export function todayKey(): string {
    return DateTime.now().toISODate();
}

/** The date key `days` days before today (local time). */
export function daysAgoKey(days: number): string {
    return DateTime.now().minus({days}).toISODate();
}

export function isFriday(): boolean {
    return DateTime.now().weekday === 5;
}

/**
 * Normalizes a legacy "YYYY/M/D" key (the app's old localStorage/date format)
 * to an ISO "YYYY-MM-DD" key. ISO input is returned unchanged.
 */
export function normalizeDateKey(key: string): string {
    const legacy = key.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
    if (legacy) {
        const [, y, m, d] = legacy;
        return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    }
    return key;
}
